// Configuración de variables de entorno para el frontend
const config = {
  // URL de la API - usar URL relativa en producción
  API_URL: process.env.REACT_APP_API_URL || '/api',
  
  // URL del Frontend - usar URL relativa en producción
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || window.location.origin,
  
  // Entorno
  ENV: process.env.REACT_APP_ENV || 'production',
  
  // Configuración de desarrollo
  IS_DEV: false,
  
  // Configuración de producción
  IS_PROD: true,
};

// Log para debugging
console.log('🔧 Environment Config:', {
  NODE_ENV: process.env.NODE_ENV,
  REACT_APP_API_URL: process.env.REACT_APP_API_URL,
  REACT_APP_FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL,
  API_URL: config.API_URL,
  FRONTEND_URL: config.FRONTEND_URL,
  IS_PROD: config.IS_PROD,
  IS_DEV: config.IS_DEV
});

export default config; 